module.exports = __webpack_public_path__ + "img/print.4fbf7775.svg";